import { render, staticRenderFns } from "./InspectModalTrigger.vue?vue&type=template&id=24e95982"
import script from "./InspectModalTrigger.vue?vue&type=script&lang=js"
export * from "./InspectModalTrigger.vue?vue&type=script&lang=js"
import style0 from "./InspectModalTrigger.vue?vue&type=style&index=0&id=24e95982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports